<template>
  <div class="subscribe-banner" v-if="hidden">
    <div class="banner-left" :style="bgImage ? { backgroundImage: `url(${bgImage})` } : {}"></div>

    <div class="banner-right">
      <div class="banner-content">
        <h1 class="banner-title">{{ title }}</h1>
        <p class="banner-desc">{{ subTitle }}</p>

        <div class="form-group">
          <div class="input-wrap">
            <input
                v-model="email"
                type="text"
                class="email-input"
                placeholder="E-mail"
                @keyup.enter="handleSubscribe"
            />
            <button class="subscribe-btn" @click="handleSubscribe">Subscribe</button>
          </div>
          <p class="error-tip" v-if="errorMsg">{{ errorMsg }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {leftLikeDict, getSubscribeExhibition} from "@/api/system";

export default {
  data() {
    return {
      hidden: true,
      title: "",
      subTitle: "",
      bgImage: "",
      email: "",
      errorMsg: ""
    };
  },
  methods: {
    async leftLikeDictFunc() {
      try {
        const res = await leftLikeDict("subscribe_us");

        // 关键修复：数组在 res.data.data 里
        const list = Array.isArray(res.data.data) ? res.data.data : [];

        // 显隐控制
        const hiddenItem = list.find(item => item.dictKey === "subscribe_usHidden");
        this.hidden = hiddenItem?.dictValue === "1";

        // 赋值标题、描述、背景图
        const titleItem = list.find(item => item.dictKey === "subscribe_usTitle");
        const subTitleItem = list.find(item => item.dictKey === "subscribe_usSubTitle");
        const imageItem = list.find(item => item.dictKey === "subscribe_usImage");

        this.title = titleItem?.dictValue || "";
        this.subTitle = subTitleItem?.dictValue || "";
        this.bgImage = imageItem?.dictValue || "";

      } catch (e) {
        console.error("leftLikeDictFunc error:", e);
      }
    },

    validateEmail(email) {
      if (!email) {
        return "Please enter your email address";
      }
      const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!reg.test(email)) {
        return "Please enter a valid email address";
      }
      return "";
    },

    async handleSubscribe() {
      this.errorMsg = "";
      const msg = this.validateEmail(this.email);
      if (msg) {
        this.errorMsg = msg;
        return;
      }
      try {
        await getSubscribeExhibition(this.email)
        this.$message.success('Submitted successfully')
      } catch (err) {
        this.$message.error('Submission failed, please try again')
      }
      this.email = "";
    }
  },
  mounted() {
    this.leftLikeDictFunc();
  }
};
</script>

<style lang="scss" scoped>
.subscribe-banner {
  width: 100%;
  height: 500px;
  display: flex;
  overflow: hidden;
  background: #000;

  @media (max-width: 768px) {
    height: auto;
    flex-direction: column;
  }

  .banner-left {
    width: 50%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: 768px) {
      width: 100%;
      height: 250px;
    }
  }

  .banner-right {
    width: 50%;
    height: 100%;
    background: #1a1a1a;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 80px;
    box-sizing: border-box;

    @media (max-width: 768px) {
      width: 100%;
      padding: 40px 20px;
      height: auto;
    }

    .banner-content {
      width: 100%;
      color: #fff;

      .banner-title {
        font-size: 48px;
        font-weight: bold;
        margin: 0 0 20px;
        font-family: 'Roboto_Bold', sans-serif;

        @media (max-width: 768px) {
          font-size: 26px;
        }
      }

      .banner-desc {
        font-size: 20px;
        line-height: 1.8;
        margin: 0 0 30px;
        color: #ccc;
        font-family: 'Roboto', sans-serif;
        white-space: pre-line;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      .form-group {
        width: 100%;

        .input-wrap {
          display: flex;

          .email-input {
            flex: 1;
            height: 56px;
            padding: 0 20px;
            border: 1px solid #880f53;
            background: transparent;
            color: #fff;
            font-size: 16px;
            outline: none;

            &::placeholder {
              color: #999;
            }

            @media (max-width: 768px) {
              height: 48px;
              font-size: 16px;
            }
          }

          .subscribe-btn {
            width: 160px;
            height: 56px;
            background: #880f53;
            color: #fff;
            border: none;
            font-size: 18px;
            font-weight: bold;
            cursor: pointer;
            transition: background 0.3s ease;

            &:hover {
              background: #6f063f;
            }

            @media (max-width: 768px) {
              width: 120px;
              height: 48px;
              font-size: 16px;
            }
          }
        }

        .error-tip {
          margin: 8px 0 0;
          color: #ff4d4f;
          font-size: 14px;

          @media (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .el-message .el-message__content {
    font-size: 16px !important;
  }
}
</style>